/*
 * doofinder-badges.js — Affiche les badges Cobra dans les résultats de recherche DooFinder.
 *
 * Le layer DooFinder est injecté dans le document principal (ni iframe ni shadow DOM),
 * donc badge.css s'y applique déjà : ce script ne fait que produire le même markup que
 * le snippet badge.liquid, dans les points de montage posés par le Product Card Template.
 *
 * Points de montage (Product Card Template DooFinder, desktop ET mobile) :
 *   <div class="cobra-df-badges"
 *        data-cobra-pid={@item["group_id"]}
 *        data-cobra-cols={Enum.join(@item["category_merchandising"] || [], ",")}></div>
 *
 * Sans point de montage, ce script ne fait strictement rien.
 * Toute la logique de sélection est alignée sur badge.liquid — si l'une change, changer l'autre.
 */
(function () {
  'use strict';

  var MOUNT = '.cobra-df-badges';
  var DONE = 'cobraDfDone';

  function readData() {
    var el = document.getElementById('cobra-df-badges-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  var data = readData();
  if (!data || !Array.isArray(data.badges) || !data.badges.length) return;

  var badges = data.badges;
  // Horloge de la boutique, fournie par Liquid au rendu de la page. On s'aligne ainsi sur
  // badge.liquid plutôt que sur le fuseau du visiteur, sinon un client hors de France
  // pourrait voir un badge que la fiche produit n'affiche pas (ou l'inverse).
  var nowTs = Number(data.now_ts) || Math.floor(Date.now() / 1000);
  var weekday = Number(data.weekday) || 1;   // 1 = lundi … 7 = dimanche
  var nowTime = data.now_time || '00:00';    // "HH:MM"

  function gidId(gid) {
    return String(gid || '').split('/').pop();
  }

  // Handle produit, lu sur la carte DooFinder (`dfd-value-link`).
  // C'est le SEUL identifiant produit fiable de l'index : `group_id` et
  // `df_grouping_id` valent tantôt l'id produit, tantôt l'id de VARIANTE
  // selon la façon dont l'article a été indexé — d'où des badges qui
  // s'affichaient sur certains produits et pas sur d'autres.
  function handleDeLaCarte(mount) {
    var card = mount.closest ? mount.closest('.dfd-card') : null;
    var link = (card && card.getAttribute('dfd-value-link')) || '';
    var apres = link.split('/products/')[1];
    if (!apres) return '';
    return apres.split('?')[0].split('#')[0].split('/')[0];
  }

  // Le handle prime ; l'id reste en repli pour les badges dont les handles
  // n'ont pas encore été résolus par la migration de l'app.
  function matchProduit(gids, handles, pid, handle) {
    if (handle && (handles || []).some(function (h) { return h && h === handle; })) return true;
    return (gids || []).some(function (g) { return gidId(g) === pid; });
  }

  function toTs(date, time, fallbackTime) {
    // Interprété dans le fuseau du navigateur, comme les dates saisies dans l'app.
    var t = time || fallbackTime;
    var d = new Date(date + 'T' + t);
    var ms = d.getTime();
    return isNaN(ms) ? null : Math.floor(ms / 1000);
  }

  function isVisible(b) {
    if (b.active === false) return false;
    if (b.doofinder === false) return false;   // décoché dans l'app

    if (b.startDate) {
      var s = toTs(b.startDate, b.startTime, '00:00:00');
      if (s !== null && nowTs < s) return false;
    }
    if (b.endDate) {
      var e = toTs(b.endDate, b.endTime, '23:59:59');
      if (e !== null && nowTs > e) return false;
    }

    if (b.weekdays && b.weekdays.length && b.weekdays.indexOf(weekday) === -1) return false;

    // Plage horaire récurrente : uniquement sans dates et si les heures ne sont pas celles par défaut.
    if (!b.startDate && !b.endDate) {
      if (b.startTime && b.startTime !== '00:00' && nowTime < b.startTime) return false;
      if (b.endTime && b.endTime !== '23:59' && nowTime > b.endTime) return false;
    }
    return true;
  }

  function isTargeted(b, pid, cols, handle) {
    var t = b.targeting || {};
    var type = t.type || 'all_products';
    var hit = false;

    if (type === 'all_products') {
      hit = true;
    } else if (type === 'products_include') {
      hit = matchProduit(t.products_include, t.products_include_handles, pid, handle);
    } else if (type === 'collections_include') {
      // L'index DooFinder identifie les collections par handle, pas par GID.
      // Un badge dont les handles n'ont pas encore été résolus par l'app est simplement
      // ignoré ici — pas d'affichage faux, il apparaîtra après la migration.
      hit = (t.collections_include_handles || []).some(function (h) {
        return h && cols.indexOf(h) !== -1;
      });
    }

    if (hit && matchProduit(t.products_exclude, t.products_exclude_handles, pid, handle)) hit = false;
    if (hit && (t.collections_exclude_handles || []).some(function (h) {
      return h && cols.indexOf(h) !== -1;
    })) hit = false;

    return hit;
  }

  function styleFor(b) {
    var c1 = b.color1 || '#971928';
    var bg = b.color2
      ? 'background:linear-gradient(' + (b.direction || '135deg') + ',' + c1 + ',' + b.color2 + ')'
      : 'background:' + c1;
    var css = bg
      + ';border-radius:' + (b.borderRadius || '6px')
      + ';color:' + (b.textColor || '#fff');
    if (b.borderColor && Number(b.borderWidth) > 0) {
      css += ';border:' + Number(b.borderWidth) + 'px solid ' + b.borderColor;
    }
    return css;
  }

  function fill(mount) {
    if (mount.dataset[DONE] === '1') return;
    mount.dataset[DONE] = '1';

    var pid = mount.getAttribute('data-cobra-pid') || '';
    var cols = (mount.getAttribute('data-cobra-cols') || '')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var handle = handleDeLaCarte(mount);
    if (!pid && !handle) return;

    var matched = badges.filter(function (b) {
      return isVisible(b) && isTargeted(b, pid, cols, handle);
    });
    if (!matched.length) return;

    // Même markup que badge.liquid en contexte 'card'. Pas de lien : la carte DooFinder
    // est déjà cliquable, un <a> imbriqué entrerait en conflit avec sa navigation.
    var wrap = document.createElement('div');
    wrap.className = 'cobra-badges-wrap';
    matched.forEach(function (b) {
      var span = document.createElement('span');
      span.className = 'cobra-badge cobra-badge--card cobra-badge--' + (b.fontSize || 'md');
      span.setAttribute('style', styleFor(b));
      span.textContent = b.label || '';   // textContent = pas d'injection possible
      wrap.appendChild(span);
    });
    mount.appendChild(wrap);
  }

  function run() {
    try {
      var mounts = document.querySelectorAll(MOUNT);
      for (var i = 0; i < mounts.length; i++) fill(mounts[i]);
    } catch (e) {
      // Un badge ne doit jamais casser la recherche.
      if (window.console) console.warn('[cobra] doofinder-badges:', e);
    }
  }

  run();

  // Le layer re-rend ses cartes à chaque frappe : on réagit aux mutations, en throttlant
  // pour ne pas travailler à chaque micro-changement du DOM.
  var pending = null;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = setTimeout(function () { pending = null; run(); }, 60);
  });
  try {
    observer.observe(document.body, { childList: true, subtree: true });
  } catch (e) { /* pas d'observer : le premier run() a déjà eu lieu */ }
})();
